import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../../../../_metronic/_partials/controls";

// Validation schema
const BusinessEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Minimum 2 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Name is required"),
 
});

export function BusinessHourForm({
  business,
  btnRef,
  saveBusiness,
}) {
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={business}
        validationSchema={BusinessEditSchema}
        onSubmit={(values) => {
          saveBusiness(values);
        }}
      >
        {({ handleSubmit }) => (
          <>
          <Form className="form form-label-right">
             <div className="form-group row" >
                  <div className="col-lg-12">
                    <p style={{ margin: "0.8rem 0" }}><b>Monday</b></p>
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      name={`business_hours[0].start_time`}
                      component={Input}
                      placeholder="Start Time"
                      label="Start Time"
                    />
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      component={Input}
                      placeholder="Ending Time"
                      label="Ending Time"
                      name={`business_hours[0].end_time`}
                    />
                  </div>

                  <div className="col-lg-12">
                    <p style={{ margin: "0.8rem 0" }}><b>Tuesday</b></p>
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      name={`business_hours[1].start_time`}
                      component={Input}
                      placeholder="Start Time"
                      label={`Start Time`}
                    />
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      component={Input}
                      placeholder="Ending Time"
                      label="Ending Time"
                      name={`business_hours[1].end_time`}
                    />
                  </div>

                  <div className="col-lg-12">
                    <p style={{ margin: "0.8rem 0" }}><b>Wednesday</b></p>
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      name={`business_hours[2].start_time`}
                      component={Input}
                      placeholder="Start Time"
                      label={`Start Time`}
                    />
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      component={Input}
                      placeholder="Ending Time"
                      label="Ending Time"
                      name={`business_hours[2].end_time`}
                    />
                  </div>

                  <div className="col-lg-12">
                    <p style={{ margin: "0.8rem 0" }}><b>Thursday</b></p>
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      name={`business_hours[3].start_time`}
                      component={Input}
                      placeholder="Start Time"
                      label={`Start Time`}
                    />
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      component={Input}
                      placeholder="Ending Time"
                      label="Ending Time"
                      name={`business_hours[3].end_time`}
                    />
                  </div>

                  <div className="col-lg-12">
                    <p style={{ margin: "0.8rem 0" }}><b>Friday</b></p>
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      name={`business_hours[4].start_time`}
                      component={Input}
                      placeholder="Start Time"
                      label={`Start Time`}
                    />
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      component={Input}
                      placeholder="Ending Time"
                      label="Ending Time"
                      name={`business_hours[4].end_time`}
                    />
                  </div>

                  <div className="col-lg-12">
                    <p style={{ margin: "0.8rem 0" }}><b>Saturday</b></p>
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      name={`business_hours[5].start_time`}
                      component={Input}
                      placeholder="Start Time"
                      label={`Start Time`}
                    />
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      component={Input}
                      placeholder="Ending Time"
                      label="Ending Time"
                      name={`business_hours[5].end_time`}
                    />
                  </div>

                  <div className="col-lg-12">
                    <p style={{ margin: "0.8rem 0" }}><b>Sunday</b></p>
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      name={`business_hours[6].start_time`}
                      component={Input}
                      placeholder="Start Time"
                      label={`Start Time`}
                    />
                  </div>
                  <div className="col-lg-5">
                    <Field
                      type="time"
                      component={Input}
                      placeholder="Ending Time"
                      label="Ending Time"
                      name={`business_hours[6].end_time`}
                    />
                  </div>


                </div>
           
           <button
                style={{ display: "none" }}
                type="submit"
                ref={btnRef}
                onSubmit={() => handleSubmit()}
              >Submit</button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
